module.exports = __webpack_public_path__ + "img/syl_gallery6.60ecf14d.jpg";